<button
  class="h-12 rounded-full flex items-center justify-center font-bold cursor-pointer text-secondary-focus min-w-[216px] outline-secondary-focus"
>
  <span id="arrow-left" class="mr-3"></span> Back
</button>
